/**
 * OnboardingGate – wraps the app content and renders the onboarding
 * overlay when a demo-mode user logs in for the first time.
 */
import { useOnboardingCheck, OnboardingFlow } from '@/modules/shared/components/OnboardingFlow';
import { isDemoModeEnabled } from '@/modules/shared/services/demoFlowService';

export function OnboardingGate({ children }: { children: React.ReactNode }) {
  const { shouldShowOnboarding } = useOnboardingCheck();

  if (!isDemoModeEnabled()) return <>{children}</>;

  return (
    <>
      {children}
      {shouldShowOnboarding && <OnboardingFlow />}
    </>
  );
}
